import { assign } from 'xstate';

import assertEventType from 'common/bento/lib/assertEventType';
import { MachineActions } from 'common/bento/types/MachineConfig';

import { Model } from './model';

export enum Action {
  AssignPaymentRequest = 'assignPaymentRequest',
  AssignSelectedPackage = 'assignSelectedPackage',
}

const actions: MachineActions<Model, Action> = {
  assignPaymentRequest: assign((context, event) => {
    assertEventType(event, 'done.invoke.getPaymentIntent');

    const { clientSecret, paymentIntentId, readyForCapture, setupIntentId } =
      event.data.data?.getSasuCreationPaymentIntent ?? {
        clientSecret: null,
        paymentIntentId: null,
        readyForCapture: null,
        setupIntentId: null,
      };

    return {
      paymentData: {
        clientSecret,
        paymentIntentId,
        readyForCapture,
        setupIntentId,
      },
    };
  }),

  assignSelectedPackage: assign((context, event) => {
    assertEventType(event, 'SAVE_SELECTED_PACKAGE');

    return {
      selectedPackage: event.data,
      selectedPlan: event.data.plan,
    };
  }),
};

export default actions;
